document.querySelectorAll('[data-contact-form]').forEach(form => {
  form.noValidate = true;
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[data-form-status]');
  const groups = [...form.querySelectorAll('[data-field]')];
  let sending = false;
  function showStatus(message, success = false) {
    status.textContent = message;
    status.hidden = false;
    status.classList.toggle('contact-form__status--success', success);
    status.focus();
  }
  function markError(group, message) {
    const error = group.querySelector('[data-field-error]');
    error.textContent = message;
    error.hidden = !message;
    group.querySelectorAll('input,select,textarea').forEach(input => {
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
      input.classList.toggle('is-invalid', Boolean(message));
    });
  }
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (sending) return;
    groups.forEach(group => markError(group, ''));
    const invalid = groups.filter(group => {
      const input = [...group.querySelectorAll('input,select,textarea')].find(item => !item.validity.valid);
      if (!input) return false;
      markError(group, (input.validity.valueMissing ? group.dataset.requiredMessage : group.dataset.invalidMessage) || input.validationMessage);
      return true;
    });
    if (invalid.length) {
      showStatus(form.dataset.validationMessage);
      invalid[0].querySelector('input,select,textarea').focus();
      return;
    }
    sending = true;
    const label = button.textContent;
    button.disabled = true;
    button.textContent = form.dataset.sendingLabel;
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        groups.forEach(group => { if (data.errors?.[group.dataset.field]) markError(group, data.errors[group.dataset.field]); });
        showStatus(data.message || form.dataset.errorMessage);
        groups.find(group => !group.querySelector('[data-field-error]').hidden)?.querySelector('input,select,textarea').focus();
        return;
      }
      form.querySelector('[data-form-fields]').hidden = true;
      showStatus(data.message, true);
    } catch {
      // Keep both entered values and the signed ticket for safe, idempotent retries.
      showStatus(form.dataset.errorMessage);
    } finally {
      sending = false;
      button.disabled = false;
      button.textContent = label;
      form.removeAttribute('aria-busy');
    }
  });
});
